import React, { useContext } from "react";
import { PageContext } from "src/utils/context";

const CtaReferrer = ({ register }) => {
    const { ctaReferrer } = useContext(PageContext)
    return(
        <div className="opacity-0 invisible">
            <label for="cta_referrer" className="block font-bold text-xs tracking-[1px] mb-2 text-darkblue uppercase">Cta Referrer</label>
            <input {...register("cta_referrer")} className="py-3 px-4 block w-full placeholder-gray-300 text-sm rounded-md focus:ring-transparent focus:border-brightgreen border-gray-200" type="text" name="cta_referrer" id="cta_referrer" value={ctaReferrer} />
        </div>
    )
}

export default CtaReferrer